// Billing B3.1 + B3.2 + B3.3. What the booker still owes on a booking, in cents, for the
// "Pending Payment" line. The server's rule is functions/helper/price.js
// (priceOf + balanceCharge, without the late fee);
// functions/test/price-copy.test.js fails if this gives a different amount.

const isCents = (n) => Number.isInteger(n) && n >= 0;

const storedCents = (value) => {
  const n = typeof value === 'string' && value.trim() !== '' ? Number(value.trim()) : value;
  return Number.isInteger(n) && n > 0 ? n : null;
};

/** The stored balance; for a booking from before B3.1, the rest of its stored total plus 5%. Null if unknown. */
export const pendingCents = (record) => {
  if (!record) return null;
  const { price } = record;
  if (price !== undefined && price !== null) {
    // The server refuses a breakdown it cannot read; show nothing for it too.
    const second = price.secondPayment;
    // Version 1: B3.1; version 2: B3.2 (adds the security deposit); version 3: B3.3 (adds the alcohol fee).
    if (![1, 2, 3].includes(price.version) || !isCents(price.balance) || price.balance <= 0 || !second) return null;
    const parts = ['venue', 'managementFee', 'deposit', 'alcoholFee', 'lateFee'].map((key) => second[key] ?? 0);
    if (!parts.every(isCents) || !isCents(second.amount) || parts.reduce((a, b) => a + b, 0) !== second.amount) return null;
    return second.amount;
  }
  const total = storedCents(record.totalPrice);
  if (!total) return null;
  const rest = total - Math.round(total * 0.5);
  return rest + Math.round(rest * 0.05);
};

/** $787.50 from 78750 cents. */
export const formatCents = (cents) =>
  `$${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
